<template>
	<div class="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">

		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 标题区域 -->
		<div class="max-w-5xl mx-auto text-center mb-12">
			<h1 class="text-4xl font-['Pacifico'] text-gray-900 mb-4">QIUI开发者平台服务条款</h1>
			<p class="text-gray-600">自 2025 年1 月 1日起生效</p>
		</div>

		<div class="max-w-5xl mx-auto flex gap-8 relative">
			<!-- 左侧导航 -->
			<nav class="w-64 flex-shrink-0">
				<div class="sticky top-8">
					<ul class="space-y-2">
						<li v-for="(item, index) in navItems" :key="index">
							<a :href="`#section-${index + 1}`"
								:class="{'text-blue-600 font-medium': activeSection === index + 1}"
								class="block px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors"
								@click.prevent="scrollToSection(index + 1)">
								{{ item }}
							</a>
						</li>
					</ul>
				</div>
			</nav>

			<!-- 主要内容区 -->
			<div class="flex-1 bg-white rounded-xl shadow-sm p-8">
				<div v-for="(section, index) in sections" :key="index" :id="`section-${index + 1}`" class="mb-8">
					<h2 class="text-2xl font-semibold mb-4 text-gray-900">{{ section.title }}</h2>
					<div v-for="(item, idx) in section.content" :key="idx" class="mb-4">
						<h3 class="text-lg font-medium mb-2 text-gray-800">{{ item.subtitle }}</h3>
						<p class="text-gray-600 leading-relaxed">{{ item.text }}</p>
						<p class="text-gray-600 leading-relaxed"><em>{{ item.textEn }}</em></p>
						<!-- Added English translation -->
					</div>
				</div>
			</div>

			<!-- 右侧工具栏 -->
			<div class="w-12 flex-shrink-0">
				<div class="sticky top-8 space-y-4">
					<button
						class="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center hover:bg-gray-50 transition-colors !rounded-button"
						@click="scrollToTop">
						<i class="fas fa-arrow-up text-gray-600"></i>
					</button>
					<button
						class="w-12 h-12 bg-white rounded-full shadow-sm flex items-center justify-center hover:bg-gray-50 transition-colors !rounded-button"
						@click="handlePrint">
						<i class="fas fa-print text-gray-600"></i>
					</button>
				</div>
			</div>
		</div>

		<!-- 版本信息 -->
		<div class="max-w-5xl mx-auto mt-12 text-center text-gray-500">
			<p>版本号：v1.0.0 | 最后更新日期：2025年1月1日</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isAgreed: false,
				activeSection: 1,
				navItems: [
					'1. 适用条款',
					'2. 隐私权和信息',
					'3. 使用限制',
					'4. 服务修改与终止'
				],
				sections: [{
						title: '1. 适用条款',
						content: [{
								subtitle: '1.1 服务提供方',
								text: '感谢您使用QIUI开发者平台。QIUI开发者平台（网址：https://developer.qiuitoy.com）是以下 QIUI实体面向开发者提供的一项服务：Foshan QIUI Technology Development Co.,Ltd..，在广东佛山注册的有限责任公司，主要营业地点为 Building A,Wanda Center, GuilanRoad,GuiCheng Street, Nanhai District, Foshan City，公司注册地在佛山。QIUI可能会不定期更新 QIUI实体及其地址（在本文件中统称为“QIUI”或“我们”）。您以个人身份使用QIUI开发者平台时须遵守下述 QIUI开发者平台服务条款（以下简称“条款”）。',
								textEn: 'Thank you for using the QIUI Developer Platform. The QIUI Developer Platform (website: https://developer.qiuitoy.com) is a service provided to developers by the following QIUI entity: Foshan QIUI Technology Development Co., Ltd., a limited liability company registered in Foshan, Guangdong, with its main business location at Building A, Wanda Center, Guilan Road, GuiCheng Street, Nanhai District, Foshan City. QIUI may periodically update the QIUI entity and its address (collectively referred to as "QIUI" or "we" in this document). When using the QIUI Developer Platform as an individual, you must comply with the following service terms of the QIUI Developer Platform (hereinafter referred to as "Terms").'
							},
							{
								subtitle: '1.2 年龄要求',
								text: '您必须年满 18 周岁并依所在国家/地区的相关法规达到能够与QIUI签订具有约束力的合约的法定年龄，才能接受这些条款并使用QIUI开发者平台。',
								textEn: 'You must be at least 18 years old and of legal age to enter into a binding contract with QIUI according to the relevant laws of your country/region to accept these terms and use the QIUI Developer Platform.'
							},
							{
								subtitle: '1.3 合同约束',
								text: '这些条款构成您与QIUI之间就您使用QIUI开发者平台的行为所达成的具有法律约束力的合约。',
								textEn: 'These terms constitute a legally binding agreement between you and QIUI regarding your use of the QIUI Developer Platform.'
							},
							{
								subtitle: '1.4 服务内容',
								text: 'QIUI开发者平台包括QIUI可能为您提供的QIUI开发者平台网页版、移动网页版和应用版。QIUI开发者平台的服务包括提供管理、对接文档和商品详情工具，并且针对与开发者帐号相关联的终端，会根据基于应用在已对接QIUI 相关API的表现而生成的数据提供各种指标数据及分析信息。',
								textEn: 'The QIUI Developer Platform includes the web version, mobile web version, and app version that QIUI may provide to you. The services of the QIUI Developer Platform include management, integration documentation, and product detail tools, and various metrics and analytical information based on the performance of applications connected to QIUI-related APIs will be provided for terminals associated with developer accounts.'
							}
						]
					},
					{
						title: '2. 隐私权和信息',
						content: [{
								subtitle: '2.1 数据收集',
								text: '我们在收集或使用与您使用 QIUI开发者平台的活动相关的任何数据时都会遵守QIUI的隐私权政策。此外，针对QIUI收集的 QIUI开发者平台相关数据，下面还就一些特殊情况做出了说明。',
								textEn: 'We will comply with QIUI\'s privacy policy when collecting or using any data related to your activities on the QIUI Developer Platform. Additionally, the following explains some special circumstances regarding the data collected by QIUI related to the QIUI Developer Platform.'
							},
							{
								subtitle: '2.2 使用情况信息',
								text: '当您使用 QIUI开发者平台时，QIUI会收集某些“使用情况信息”。“使用情况信息”是指与您使用  QIUI开发者平台的活动相关的信息，例如，您的网页访问情况和查看的数据、您与 QIUI开发者平台的互动（包括与管理开发者帐号中的应用相关的互动）、您在使用QIUI API时执行的操作、您登录  QIUI开发者平台所用的电子邮件地址、IP 地址以及与这类活动相关的时间戳。QIUI会将这些使用情况信息与开发者帐号关联起来。',
								textEn: 'When you use the QIUI Developer Platform, QIUI collects certain "usage information." "Usage information" refers to information related to your activities on the QIUI Developer Platform, such as your web page visits and viewed data, your interactions with the QIUI Developer Platform (including interactions related to managing applications in your developer account), actions you perform while using the QIUI API, the email address you use to log in to the QIUI Developer Platform, your IP address, and timestamps related to these activities. QIUI associates this usage information with developer accounts.'
							},
							{
								subtitle: '2.3 信息共享',
								text: 'QIUI会与帐号所有者共享收集的所有使用情况信息，以供其用于各种用途，例如可方便管理开发者帐号，包括审核各种操作和监控可能存在的滥用情况。',
								textEn: 'QIUI will share all collected usage information with account owners for various purposes, such as facilitating the management of developer accounts, including reviewing various operations and monitoring potential abuse.'
							},
							{
								subtitle: '2.4 信息保留',
								text: '在开发者帐号存续期间，QIUI 会一直保留其关联的使用情况信息。此保留期限与您能否访问  QIUI开发者平台或用户登录凭据状态的变化（包括停用凭据）无关。',
								textEn: 'QIUI will retain the associated usage information for the duration of the developer account. This retention period is independent of whether you can access the QIUI Developer Platform or the status of user login credentials (including disabled credentials).'
							}
						]
					},
					{
						title: '3. 使用限制',
						content: [{
							subtitle: '使用规范',
							text: '您不得出于以下目的使用 QIUI开发者平台：超出这些条款和 QIUI开发者平台文档中所述 QIUI开发者平台预期用途的目的；参与、推动或鼓励非法活动或滥用行为；针对 QIUI开发者平台的任何元素进行破坏、干扰、逆向工程或规避；或者以违反任何其他QIUI产品或服务的服务条款的方式使用相应QIUI产品或服务。',
							textEn: 'You may not use the QIUI Developer Platform for the following purposes: for purposes beyond the intended use of the QIUI Developer Platform as described in these terms and the documentation; to engage in, promote, or encourage illegal activities or abusive behavior; to damage, interfere with, reverse engineer, or circumvent any element of the QIUI Developer Platform; or to use any other QIUI products or services in violation of their respective terms of service.'
						}]
					},
					{
						title: '4. 服务修改与终止',
						content: [{
								subtitle: '4.1 服务变更',
								text: 'QIUI随时可出于任何原因，自行决定更改、停止提供任何 QIUI开发者平台服务或功能（包括报告指标）或者限制对其的访问权限，且无需因此向您或帐号所有者承担任何责任。',
								textEn: 'QIUI may change or discontinue any QIUI Developer Platform service or feature (including reporting metrics) or restrict access to it at any time for any reason, without incurring any liability to you or account owners.'
							},
							{
								subtitle: '4.2 终止通知',
								text: '如果QIUI停止提供 QIUI开发者平台，QIUI会尽合理努力提前向您发出通知。如果QIUI停止提供任何顶级指标或报告功能，会尽可能至少提前三十 (30) 天通过产品内消息、电子邮件、博文或其他合理的方式发出书面通知。',
								textEn: 'If QIUI stops providing the QIUI Developer Platform, QIUI will make reasonable efforts to notify you in advance. If QIUI stops providing any top-level metrics or reporting features, it will provide written notice at least thirty (30) days in advance, if possible, through in-product messages, emails, blog posts, or other reasonable means.'
							},
							{
								subtitle: '4.3 条款变更',
								text: 'QIUI随时可能会对这些条款做出变更，在发生变更的情况下，会向您发出通知，并给您选择拒绝继续使用 QIUI开发者平台的机会,QIUI会在 QIUI开发者平台（网址：developer.qiuitoy.com) 内发布条款修改通知，并向您的联系电子邮件地址发送通知邮件。变更不具有追溯效力。变更生效且视为您已予以接受的情况有以下两种：(a) 对于在通知发布后成为帐号所有者或 QIUI开发者平台用户的人员，变更会立即生效；(b) 对于既有的帐号所有者或 QIUI开发者平台用户，变更会于通知中指定的日期（变更发布三十 (30) 天或更长时间后）生效，但涉及 QIUI开发者平台新功能的变更或法律要求的变更会立即生效。',
								textEn: 'QIUI may change these terms at any time and will notify you of any changes, giving you the opportunity to refuse to continue using the QIUI Developer Platform. QIUI will publish a notice of changes to the terms on the QIUI Developer Platform (website: developer.qiuitoy.com) and send a notification email to your contact email address. Changes will not have retroactive effect. Changes will be effective and deemed accepted by you in the following two cases: (a) for individuals who become account owners or users of the QIUI Developer Platform after the notice is published, the changes will take effect immediately; (b) for existing account owners or users of the QIUI Developer Platform, the changes will take effect on the date specified in the notice (30 days or longer after the change is published), but changes related to new features of the QIUI Developer Platform or legal requirements will take effect immediately.'
							},
							{
								subtitle: '4.4 终止权利',
								text: '如果您对这些条款的修改内容存有异议，则可终止使用 QIUI开发者平台，这将是您在条款发生修改后能采取的唯一补救方法。您同意，继续 QIUI开发者平台即表示您接受经过修改的条款。',
								textEn: 'If you disagree with any modifications to these terms, you may terminate your use of the QIUI Developer Platform, which will be your only remedy after the terms have been modified. You agree that continuing to use the QIUI Developer Platform indicates your acceptance of the modified terms.'
							},
							{
								subtitle: '4.5 访问权限终止',
								text: '如果您违反这些条款中的任何规定，QIUI均可终止您对 QIUI开发者平台的访问权限。此外，在法律允许的最大限度内，QIUI可出于任何原因终止您的访问权限，但会提前三十 (30) 天发出书面通知。',
								textEn: 'If you violate any provisions of these terms, QIUI may terminate your access to the QIUI Developer Platform. Additionally, to the maximum extent permitted by law, QIUI may terminate your access for any reason, but will provide written notice thirty (30) days in advance.'
							}
						]
					},
					{
						title: '5. 一般法律条款',
						content: [{
							subtitle: '5.1 管辖法律',
							text: '对于因这些条款或您与QIUI据这些条款建立的关系而产生或与之相关的所有索赔，一概适用 QIUI注册地所述的管辖法律和管辖区。',
							textEn: 'All claims arising out of or related to these terms or your relationship with QIUI established under these terms shall be governed by the laws and jurisdiction of QIUI\'s registered location.'
						}]
					}
				]
			};
		},
		methods: {
			handleScroll() {
				const sections = document.querySelectorAll('[id^="section-"]');
				const scrollPosition = window.scrollY + 200;

				sections.forEach((section) => {
					const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
					const sectionId = parseInt(section.id.split('-')[1]);

					if (scrollPosition >= sectionTop) {
						this.activeSection = sectionId;
					}
				});
			},
			scrollToSection(sectionNumber) {
				const element = document.getElementById(`section-${sectionNumber}`);
				if (element) {
					element.scrollIntoView({
						behavior: 'smooth'
					});
				}
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			},
			handlePrint() {
				window.print();
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		}
	};
</script>

<style>
	@media print {
		.no-print {
			display: none;
		}
	}
</style>